import { render, staticRenderFns } from "./period-selector.vue?vue&type=template&id=9dc0488e&"
import script from "./period-selector.vue?vue&type=script&lang=ts&"
export * from "./period-selector.vue?vue&type=script&lang=ts&"
import style0 from "./period-selector.vue?vue&type=style&index=0&id=9dc0488e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports